import {
  Alert,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Switch,
  Typography,
} from 'antd'
import { defaultDate, defaultTime, formatDateTime, parseDateTime, shortDateTime } from '../../util/dateTimeUtil'

import AppContext from '../common/AppContext'
import Message from '../common/Message'
import _ from 'lodash'
import { endOfDay } from 'date-fns'
import { format } from 'date-fns-tz'
import { isLastMinute } from '../../util/bookingUtil'
import { parse } from 'graphql'
import { useContext } from 'react'
import { useEffect } from 'react'
import { useForm } from 'antd/lib/form/Form'
import useResponsive from '../../hooks/useResponsive'
import { useWindowSize } from '../../hooks/useWindowSize'

const { Text, Paragraph, Title } = Typography
const { TextArea } = Input

const DATETIME_FORMAT = 'yyyy-MM-dd HH:mm:ss'
const DATETIME_REGEX =
  /(19|20)\d{2}-(0[1-9]|1[0,1,2])-(0[1-9]|[12][0-9]|3[01]) (0[0-9]|1[0-9]|2[0-3]):[0-5]+[0-9]+:[0-5]+[0-9]+/g

const MessageModal = ({ visible, onOk, onCancel, messageToEdit }) => {
  const { currentUser } = useContext(AppContext)
  const isNew = _.isNil(messageToEdit?.id)
  const [form] = Form.useForm()
  const bp = useResponsive()

  const handleOk = () => {
    const fields = { ...messageToEdit, ...form.getFieldsValue(true) }
    onOk(fields)
  }

  const handleCancel = () => {
    onCancel()
  }

  const getEndOfDayDateTime = () => formatDateTime(endOfDay(new Date()), DATETIME_FORMAT)

  const handleSetExpiresToEndOfDay = () => {
    form.setFieldsValue({ expires: getEndOfDayDateTime() })
  }

  useEffect(() => {
    if (visible) {
      form.resetFields()
      let fields
      if (messageToEdit) {
        const { expires } = messageToEdit
        fields = {
          ...messageToEdit,
          updatedByUser: currentUser,
          expires: formatDateTime(new Date(expires), DATETIME_FORMAT),
        }
        form.setFieldsValue(fields)
      } else {
        fields = {
          expires: getEndOfDayDateTime(),
          createdByUser: currentUser,
          visible: true,
        }
      }
      form.setFieldsValue(fields)
    }
  }, [visible, form, messageToEdit, isNew, currentUser])

  return (
    <Modal
      title={null}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={isNew ? 'Save' : 'Update message'}
      okButtonProps={{ type: 'primary' }}
      cancelButtonProps={{ type: 'link' }}
      visible={visible}
      closable={true}
      maskClosable={true}
      keyboard={true}
      destroyOnClose={true}
      width={bp.xs ? '100%' : '600px'}
    >
      <Paragraph className="messageModalHeader" level={3}>
        <>{isNew ? 'Create Message' : 'Update Message'}</>
      </Paragraph>
      <Paragraph></Paragraph>
      <Form form={form} size="small" layout="vertical" colon={false}>
        <Row gutter={10}>
          <Col>
            <Form.Item label="Enabled" name="visible" valuePropName="checked">
              <Switch size="default" />
            </Form.Item>
          </Col>
          <Col style={{ paddingLeft: '4em' }}></Col>
          <Col>
            <Form.Item
              label="Expires"
              name="expires"
              style={{ marginBottom: 0 }}
              rules={[
                {
                  required: true,
                  message: 'Required',
                },
                {
                  pattern: DATETIME_REGEX,
                  message: `Enter a valid date/time (e.g. ${formatDateTime(new Date(), DATETIME_FORMAT)})`,
                },
              ]}
              getValueProps={(value) => {
                let result = value
                try {
                  if (value.match(DATETIME_REGEX)) {
                    result = formatDateTime(value, DATETIME_FORMAT)
                  }
                } catch (e) {
                  // Ignore
                }
                return { value: result }
              }}
            >
              <Input />
            </Form.Item>
            <Form.Item>
              <Button type="link" onClick={handleSetExpiresToEndOfDay} style={{ paddingLeft: 0 }}>
                Set to 11:59 PM today
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={10}>
          <Col span={24}>
            <Form.Item
              label="Heading"
              name="heading"
              rules={[
                {
                  required: true,
                  message: 'Required',
                },
              ]}
            >
              <Input autoFocus placeholder="Message heading" />
            </Form.Item>
            <Form.Item label="Body (optional)" name="content">
              <TextArea placeholder="Message body (optional)" rows={6} />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          label="Type"
          name="messageType"
          rules={[
            {
              required: true,
              message: 'Required',
            },
          ]}
        >
          <Select dropdownMatchSelectWidth>
            <Select.Option key="cancelledWeather">Rain</Select.Option>
            <Select.Option key="cancelledOther">Cancelled</Select.Option>
            <Select.Option key="reminder">Reminder</Select.Option>
            <Select.Option key="general">Other</Select.Option>
          </Select>
        </Form.Item>
      </Form>
      {/* <MessagePreview form={form} /> */}
    </Modal>
  )
}

const MessagePreview = ({ form }) => {
  let message = form?.getFieldsValue?.(true)
  return (
    <Row>
      <Paragraph>Preview</Paragraph>
      <Message message={message} />
    </Row>
  )
}
export default MessageModal
